// Copyright (c) 2016 Deere & Company

import CreditMemo from '@deere/cps-it.warranty-model-factory/lib/credit-memo';
import t from 'tcomb';

const Report = t.list(CreditMemo, 'Report');

export const getDefaultState = () => new Report([]);

export default Report;



// WEBPACK FOOTER //
// ./src/reports/credit-memo/state/report.js